import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import Layout from "src/components/Layout";

export interface FileWithPreview extends File {
  preview: string;
}

export interface DropZoneProps {
  files: FileWithPreview[];
  setFiles: React.Dispatch<React.SetStateAction<FileWithPreview[]>>;
}

const DropZone: React.FC<DropZoneProps> = ({ files, setFiles }) => {
  const [description, setDescription] = useState<string>("");

  const onDrop = useCallback((acceptedFiles: File[]) => {
    const filesWithPreview = acceptedFiles.map((file) =>
      Object.assign(file, { preview: URL.createObjectURL(file) })
    );
    setFiles((prevFiles) => [...prevFiles, ...filesWithPreview]);
  }, []);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    const formData = new FormData();
    files.forEach((file) => {
      formData.append("files", file);
    });
    formData.append("description", description);

    try {
      const response = await fetch("YOUR_API_ENDPOINT", {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        alert("Files uploaded successfully!");
        setFiles([]);
        setDescription("");
      } else {
        alert("Failed to upload files.");
      }
    } catch (error) {
      console.error("Upload error:", error);
      alert("Network error occurred while uploading.");
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: true,
    accept: {
      "image/*": [".png", ".jpg", ".jpeg", ".gif"], // You can define accepted file types here
    },
  });

  return (
    <form
      style={{
        border: "2px dashed #007bff",
        padding: "20px",
        margin: 10
      }}
      onSubmit={handleSubmit}
    >
      <div
        {...getRootProps()}
        style={{
          cursor: "pointer",
        }}
      >
        <input {...getInputProps()} />
        <p
          style={{
            color: "#007bff",
          }}
        >
          Drag & drop files here, or click to select files
        </p>
      </div>
      {files?.length > 0 && (
        <div
          style={{
            display: "flex",
            overflowX: "auto",
            gap: "10px",
            padding: "10px",
            border: "1px solid #ddd",
            marginTop: "20px",
            borderRadius: "5px",
          }}
        >
          {files.map((file, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img
                src={file.preview}
                alt={file.name}
                style={{
                  width: "80px",
                  height: "80px",
                  objectFit: "cover",
                  borderRadius: "5px",
                }}
              />
              <span
                style={{
                  fontSize: "12px",
                  color: "#555",
                  marginTop: "5px",
                  textAlign: "center",
                }}
              >
                {file.name}
              </span>
            </div>
          ))}
        </div>
      )}
      {/* <button
        type="submit"
        style={{
          marginTop: "20px",
          padding: "10px 20px",
          backgroundColor: "#007bff",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
        }}
      >
        Upload
      </button> */}
    </form>
  );
};

export default DropZone;
